import { pluralize } from "shared/lib/plural";

// Отдельно от pluralize: формы слова повторялись уже в трёх местах (стоп-лист — таблица
// и диалог, редактор меню) и разъезжались бы по одному.
export const itemsCountLabel = (count: number): string =>
    `${count} ${pluralize(count, "позиция", "позиции", "позиций")}`;
